
import { CheckCircle, Info } from "lucide-react";

const RegisterBenefits = () => {
  return (
    <div className="bg-green-50 border border-green-200 rounded-md p-4 mb-6">
      <div className="flex items-start">
        <Info className="h-5 w-5 text-green-500 mt-0.5 mr-3" />
        <div>
          <h3 className="text-sm font-medium text-green-800">
            Benefits of joining PropertyLK
          </h3>
          <ul className="mt-1 text-sm text-green-700 space-y-1">
            <li className="flex items-center">
              <CheckCircle className="h-3.5 w-3.5 mr-2" />
              Save your favorite properties
            </li>
            <li className="flex items-center">
              <CheckCircle className="h-3.5 w-3.5 mr-2" />
              Receive property alerts
            </li>
            <li className="flex items-center">
              <CheckCircle className="h-3.5 w-3.5 mr-2" />
              Contact property owners directly
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default RegisterBenefits;
